import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'horizontal' | 'compact';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  if (variant === 'compact') {
    return (
      <Link
        to={`/article/${article.id}`}
        className="group block cursor-pointer"
      >
        <div className="flex gap-3">
          <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden">
            <img
              src={article.imageUrl}
              alt={article.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              title={`爆料网 - ${article.title}`}
            />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug mb-1">
              {article.title}
            </h3>
            <div className="flex items-center gap-2 text-xs text-foreground-500">
              <span>{article.publishDate}</span>
              <span className="flex items-center gap-0.5">
                <i className="ri-eye-line text-[10px]"></i>
                {article.viewCount > 10000
                  ? `${(article.viewCount / 10000).toFixed(1)}万`
                  : article.viewCount}
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  if (variant === 'horizontal') {
    return (
      <Link
        to={`/article/${article.id}`}
        className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
      >
        <div className="w-full sm:w-48 flex-shrink-0 rounded-lg overflow-hidden">
          <img
            src={article.imageUrl}
            alt={article.title}
            className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
            title={`爆料网 - ${article.title}`}
          />
        </div>
        <div className="flex-1 min-w-0 flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-2 mb-2 flex-wrap">
              {article.isHot && (
                <span className="px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-600 rounded-full whitespace-nowrap">
                  热门
                </span>
              )}
              {article.isNew && (
                <span className="px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                  最新
                </span>
              )}
              <span className="text-xs text-foreground-500">{article.category}</span>
            </div>
            <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug mb-2">
              {article.title}
            </h3>
            <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
              {article.excerpt}
            </p>
          </div>
          <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500 flex-wrap">
            <span>{article.author}</span>
            <span>{article.publishDate}</span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {article.viewCount > 10000
                ? `${(article.viewCount / 10000).toFixed(1)}万`
                : article.viewCount}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line"></i>
              {article.commentCount}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
    >
      <div className="relative overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
          title={`爆料网 - ${article.title}`}
        />
        <div className="absolute top-3 left-3 flex gap-1.5 flex-wrap">
          {article.isHot && (
            <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
              热门
            </span>
          )}
          {article.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
              最新
            </span>
          )}
        </div>
      </div>
      <div className="p-4">
        <span className="text-xs text-primary-600 font-medium mb-2 block">
          {article.category}
        </span>
        <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{article.publishDate}</span>
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {article.viewCount > 10000
                ? `${(article.viewCount / 10000).toFixed(1)}万`
                : article.viewCount}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line"></i>
              {article.commentCount}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}